import { makeStyles } from '@material-ui/core';
import { FtcSymbolPath } from './FtcSymbolPath';

const useStyles = makeStyles({
  svg: {
    width: 28,
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      role="img"
      aria-label="FTC"
    >
      <defs>
        <linearGradient id="ftcIconBlueGradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#001f33" />
          <stop offset="100%" stopColor="#003b5c" />
        </linearGradient>
      </defs>
      <circle cx="20" cy="20" r="18" fill="url(#ftcIconBlueGradient)" />
      <svg x="6" y="3.5" width="28" height="33" viewBox="13 9 40 48" aria-hidden="true">
        <FtcSymbolPath fill="#ffffff" />
      </svg>
    </svg>
  );
};
